import React from "react";
import Slider from "react-slick";

const HomeEstimates = () => {
  const homes = [
    {
      image: "./images/home/5.jpg", // Replace with actual image URL
      title: "Corporate Office Design, Noida",
      description: "Make the most of your 1 BHK home with space-saving solutions.",
    },
    {
      image: "./images/home/541.jpg", // Replace with actual image URL
      title: "Luxury Living Room, Gurgaon",
      description: "Transform any 3 BHK, compact or spacious, with stunning interiors.",
    },
    {
      image: "./images/home/2148225014.jpg", // Replace with actual image URL
      title: "Chic Retail Store Setup, Delhi",
      description: "Experience a different level of comfort and style in your 4 BHK.",
    },
    {
      image: "./images/home/224817.jpg", // Add more items as needed
      title: "Office Furniture",
      description: "Luxury redefined for your spacious and elegant 5 BHK home.",
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <section className="home-estimates">
      <div className="container">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <div>
            <h2 className="estimates-title">Our Recent Projects</h2>
            <p className="estimates-subtitle">
              Choose your preferred style and sit back while our estimator does its magic
            </p>
          </div>
          <button className="btn btn-primary">GET STARTED</button>
        </div>

        <Slider {...settings}>
          {homes.map((home, index) => (
            <div key={index} className="p-3">
              <div className="card home-card">
                <img
                  src={home.image}
                  className="card-img-top"
                  alt={home.title}
                />
                <div className="card-body">
                  <h5 className="card-title">{home.title}</h5>
                  <p className="card-text">{home.description}</p>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default HomeEstimates;
